//#region src/core/ui/thumbnail/data.ts
const ThumbnailDataAttrs = {
	loading: "data-loading",
	error: "data-error",
	hidden: "data-hidden"
};
//#endregion
export { ThumbnailDataAttrs };

//# sourceMappingURL=data.js.map